$(document).ready(function(){
  
// Review Slider
$(".cstm_review_slider").slick({
  infinite: false,
  slidesToShow:3,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:
    '<div class="swiper_buttons slick_left_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  nextArrow:
    '<div class="swiper_buttons slick_right_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  responsive : [
  {
    breakpoint: 989,
    settings: {
      slidesToShow: 2,
    }
  },
  {
    breakpoint: 576,
    settings: {
      slidesToShow: 1,
    } 
  }
  ]
});

 
//Multi Image with Text js
var swiper = new Swiper('.multicolumm_imagetext_main', {
  pagination: {
    el: '.swiper-pagination',
    clickable: true,  
  }, 
  slidesPerView: 'auto',
  paginationClickable: true,
  spaceBetween: 0
});
 
// Tab Collection Slider  
$(".collectiontab_slider").slick({
  infinite: false,
  slidesToShow:4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:
    '<div class="swiper_buttons slick_left_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  nextArrow:
    '<div class="swiper_buttons slick_right_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  responsive : [
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 3,
    }
  },
  {
    breakpoint: 989,
    settings: {
      slidesToShow: 2,
    }
  },
  {
    breakpoint: 576,
    settings: {
      slidesToShow: 2,
    } 
  }
  ]
});

$('li.tab_collection').click(function(){ 
 
  $(".collectiontab_slider").slick('unslick').slick({
  infinite: false,
  slidesToShow:4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:
    '<div class="swiper_buttons slick_left_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  nextArrow:
    '<div class="swiper_buttons slick_right_arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="#040404" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  responsive : [
   {
    breakpoint: 1200,
    settings: {
      slidesToShow: 3,
    }
  },
  {
    breakpoint: 989,
    settings: {
      slidesToShow: 2,
    }
  },
  {
    breakpoint: 576,
    settings: {
      slidesToShow: 2,
    } 
  }
  ]
});
});

  
// collection tab js
var fstCollection = document.querySelector('ul .tab_collection').getAttribute('data');
 document.querySelector('ul .tab_collection').classList.add('active');
document.querySelectorAll('.collectiontab_slider').forEach((df) => {
  if( df.getAttribute('slide-data') == fstCollection ){
      df.classList.add('active');
  }
});

document.querySelectorAll('.tab_collection').forEach((element) => {
element.addEventListener('click', function(){
   document.querySelectorAll('.tab_collection').forEach((el) => {
      el.classList.remove('active');
  });
  this.classList.add('active');
   var crntData = element.getAttribute('data');
    document.querySelectorAll('.collectiontab_slider').forEach((has) => {
      var slideData = has.getAttribute('slide-data');
      if( slideData == crntData ) {
          has.classList.add("active");
      }
      else{
          has.classList.remove("active");
      }
    });
});
});
 
if($(window).width() < 767){ 
$(".collage_grid_collblog").slick({
  infinite: false,
  slidesToShow:1,
  arrows: false, 
  adaptiveHeight: true,
  slidesToScroll: 1,
  dots: true,
  responsive : [
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 1,
    }
  },
  {
    breakpoint: 450,
    settings: {
      slidesToShow: 1,
    } 
  }
  ]
}); 
  
} 
 
});


// Product Description tab

document.addEventListener("DOMContentLoaded", function() { 
  const tabButtons = document.querySelectorAll('.description_data_tabs');
  const tabContents = document.querySelectorAll('.cstm_description_tab_content');
  
  if (tabButtons.length > 0 && tabContents.length > 0) {
      tabButtons[0].classList.add('active_data');
      tabContents[0].classList.add('active_data');
  }

  tabButtons.forEach(button => {
      button.addEventListener('click', function() {
          const tabId = this.getAttribute('data-tab');

          tabButtons.forEach(btn => btn.classList.remove('active_data'));
          tabContents.forEach(content => content.classList.remove('active_data'));

          this.classList.add('active_data');
          document.querySelector(`.cstm_description_tab_content[data-id="${tabId}"]`).classList.add('active_data');
      });
  });
});


$(document).ready(function() {
  // Prevent redirect and show popup when the checkout button is clicked
  $('.button[name="checkout"]').click(function(event) {
    event.preventDefault(); 
    $('#addons_accessoriescart_popup').css('display', 'block'); 
  });

  // Close the popup and redirect to the checkout page
  $('.close_addonpopup_cart').click(function() {
    $('#addons_accessoriescart_popup').css('display', 'none');
    window.location.href = '/checkout'; 
  });
 
});
function hidePopup() {
  document.getElementById("addons_accessoriesproduct_popup").style.display = "none";
}

// Product swatch Js

document.addEventListener('DOMContentLoaded', function() {
  const radioButtons = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
  radioButtons.forEach(radio => {
    radio.removeAttribute('checked'); // Removes the 'checked' attribute
  });
});


$(document).ready(function(){ 

$('.product_with_variants button.product-form__submit').on('click', function() {  
  var checkedCount = $('.product-form__input--pill input[type="radio"]:checked').length;

  if (checkedCount === 0) {
    $('.product_error_message').show();  
    return false;  
  } else {
    $('.product_error_message').hide();
  }   
});
  
$('.product-form__input--pill input[type="radio"]').on('click', function() { 
  var noInstallationChecked = $(this).hasClass('no_installation_variant');
    if (noInstallationChecked) {
     $('.product_error_message').show();
    }else{
      $('.product_error_message').hide(); 
    }
});
  
// FAQ Accordian Js
$(".accordian_contains").hide();
$(".accordion_in_flxs").click(function () {
  $(".accordion_in_icons").css("transform", "rotate(0deg)");
  if ($(".accordian_contains").is(":visible")) {
    $(".accordian_contains").slideUp(300);
  }
  if ($(this).next(".accordian_contains").is(":visible")) {
    $(this).next(".accordian_contains").slideUp(300);
    $(this).closest(".accordion_inners").find(".accordion_in_icons ").css("transform", "rotate(0deg)");
  } else {
    $(this).next(".accordian_contains").slideDown(300);
    $(this).closest(".accordion_inners").find(".accordion_in_icons").css("transform", "rotate(180deg)");
  }
  $('.accordion_in_flxs').removeClass('colored_text');
  $(this).addClass('colored_text');
}); 
 
});
  
// Mobile filter JS
document.querySelectorAll('.ast_collection_cstm .mobile-facets__open-wrapper').forEach(function(trigger) {
  trigger.addEventListener('click', function() {
    document.querySelectorAll('.mobile_cstm_detail_filter').forEach(function(filter) {
      filter.setAttribute('open', '');
    });
  });
}); 

// -------------------------- wishList JS --------------------------- */

document.addEventListener('DOMContentLoaded',function(){
    let WishListArray = [];
  
    // =============== Get Cookie ===============
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        const cookieValue = parts[1].split(';')[0]; 
        console.log('Wishlist items:', JSON.parse(decodeURIComponent(cookieValue)));
        return JSON.parse(decodeURIComponent(cookieValue));
      }
    }
  
    if(getCookie('wishlist')){
       WishListArray = getCookie('wishlist');
    }
  
    
    // =============== Set Cookie ===============
    function setCookie(WishListArray) {
      const wishlistString = JSON.stringify(WishListArray);
      document.cookie = `wishlist=${encodeURIComponent(wishlistString)}; path=/; max-age=${100 * 24 * 60 * 60}; SameSite=None; Secure`;
      WishListArray = getCookie('wishlist');
    }
  
    // =============== PopupOpen Function ===============
    function PopupOpen() {
        document.querySelector('.Popup').style.setProperty('display','block');
        document.querySelector('body').classList.add('OverFlowHidden');
        setTimeout(()=>{
            document.querySelector('.Popup').style.setProperty('opacity','1');
            document.querySelector('.Popup').style.setProperty('visibility','visible') 
        },100)
    }
  
    // =============== PopupClose Function ===============
    function PopupClose() {
        document.querySelector('body').classList.remove('OverFlowHidden');
        document.querySelector('.Popup').style.setProperty('opacity','0');
        document.querySelector('.Popup').style.setProperty('visibility','hidden') 
        setTimeout(()=>{
            document.querySelector('.Popup').style.setProperty('display','none');  
        },250) 

    }
  
    // =============== get Popup Data ===============
    function getPopupData(WishListArray) {
      
      document.querySelector('.productdata-container').innerHTML = '';
      WishListArray.forEach((data)=>{
        $.ajax({
          url: `/products/${data}`,
          type: 'GET',
          dataType: 'html', 
          success: function(response) {
            const ProductDiv = document.createElement('div');
            ProductDiv.innerHTML = response;
  
            let ProductRow  = document.createElement('div');
            ProductRow.className = 'product-row';
            
            // --------- Image ==>
            let ImgDiv = document.createElement('div');
            ImgDiv.className = 'product-img';
            let ImgDivInner = document.createElement('div');
            ImgDivInner.className = 'product-img-inner';
            let imgtag = document.createElement('img');
            imgtag.src = ProductDiv.querySelector('.product__media-wrapper .product__media-item.is-active .product__media img').getAttribute('src');
            imgtag.alt = ProductDiv.querySelector('.product__media-wrapper .product__media-item.is-active .product__media img').getAttribute('src');
            ImgDivInner.appendChild(imgtag);
            ImgDiv.appendChild(ImgDivInner);
            
            // --------- Title ==>
            let TitleDiv = document.createElement('div');
            TitleDiv.className = 'product-title';
            let Titlehead = document.createElement('h2');
            Titlehead.textContent = ProductDiv.querySelector('.product__info-wrapper .product__title h1').textContent;
            TitleDiv.appendChild(Titlehead);
            
            // --------- Price ==>
            let PriceDiv = document.createElement('div');
            PriceDiv.className = 'product-price';
            let Pricepara = document.createElement('p');
            Pricepara.textContent = ProductDiv.querySelector('.product__info-wrapper .price__container .price-item--sale').textContent;
            PriceDiv.appendChild(Pricepara);
            
            // --------- Quantity ==>
            let QuantityDiv = document.createElement('div');
            QuantityDiv.className = 'product-quantity';
            let QuantityInner = document.createElement('div');
            QuantityInner.innerHTML = ProductDiv.querySelector('.price-per-item__container').innerHTML;
            QuantityDiv.appendChild(QuantityInner);
            
            // --------- variant Options ==>
            let VariantDiv = document.createElement('div');
            VariantDiv.className = 'product-variant-options';
            let VariantDivInner = document.createElement('div');
            VariantDivInner.innerHTML = ProductDiv.querySelector('.product__info-wrapper .productVariants-hidden').innerHTML
            VariantDiv.appendChild(VariantDivInner);
            
            // --------- Action ==>
            let ActionDiv = document.createElement('div');
            ActionDiv.className = 'product-action';
            let cartIcon = document.createElement('span');
            cartIcon.className = 'AddCart';
            cartIcon.innerHTML = document.getElementById('PopupCartIcon').innerHTML;
            let DeleteIcon = document.createElement('span');
            DeleteIcon.className = 'DeleteFromList'
            DeleteIcon.setAttribute('data-product-handle',data);  
            DeleteIcon.textContent = '×';
            ActionDiv.appendChild(DeleteIcon);
            ActionDiv.appendChild(cartIcon);
            
            ProductRow.append(ImgDiv);
            ProductRow.append(TitleDiv);
            ProductRow.append(PriceDiv);
            ProductRow.append(QuantityDiv);
            ProductRow.append(VariantDiv);
            ProductRow.append(ActionDiv);
            
            document.querySelector('.productdata-container').append(ProductRow);
            
            document.querySelector('.Popup #LoadSpinner').style.setProperty('display','none');

          },
          
        })
      })
      
      document.querySelector('.productdata-container').addEventListener('click', function (event) {
          // ------------- Add to cart Functionality -------------
          if (event.target.closest('.AddCart')) {
              const productRow = event.target.closest('.product-row')
              let SelectedVarId = productRow.querySelector('.product-variant-options select').value;
              let SelectedVarQty = Number(productRow.querySelector('.product-quantity .quantity__input').value);
              let data = {
                id: SelectedVarId,
                quantity: SelectedVarQty
              };
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function() { 
                  console.log(data);
                  alert('Item added to cart.')
                },
                error: function(error){
                  console.log(error);
                  alert('Quantity not available.')
                }
              });
          } 
          // ------------- Delete Functionality -------------
          else if (event.target.closest('.DeleteFromList')) {
              const productRow = event.target.closest('.product-row');
              if (productRow) productRow.remove(); 
              const productHandleToRemove = event.target.getAttribute('data-product-handle');
              if(productHandleToRemove){
                WishListArray = WishListArray.filter(handle => handle !== productHandleToRemove);
                setCookie(WishListArray);
                // WishListArray = getCookie('wishlist');
                // if(WishListArray.length == 0){
                //    PopupClose()
                // }
                // console.log('WishListArray After Delete--',WishListArray);
              }
          }
        
      });
      
    }

  
    if(WishListArray.length > 0) {
      getPopupData(WishListArray); 
    }

    // =============== Add to wishlist ===============
    document.querySelectorAll('.cstm_whislist_icon.wishList').forEach((WishListButton)=>{
         WishListButton.onclick = function () {
            WishListArray = getCookie('wishlist');
            let dataHandle = this.getAttribute('data-product-handle');
           console.log('w',WishListArray)
             if(WishListArray){
                let handleExists = WishListArray.find(handle=> handle == dataHandle);
                // console.log('dataHandle==',dataHandle)
                console.log('handleExists==',handleExists)
                if(!handleExists){
                  document.querySelector('.Popup #LoadSpinner').style.setProperty('display','block');
                  console.log("New Handle Found ===",handleExists);
                  WishListArray.push(dataHandle);
                  setCookie(WishListArray);
                  getPopupData(WishListArray);
                  
                  // console.log("WishListArray------",WishListArray);
                }else{
                  console.log("Already handleExists");
                  // console.log("WishListArray------",WishListArray);
                }
             }
             else{
                WishListArray = [];
                document.querySelector('.Popup #LoadSpinner').style.setProperty('display','block');
                WishListArray.push(dataHandle);
                setCookie(WishListArray);
                getPopupData(WishListArray);
             }
      
            // ------------- Popup Open -------------
            PopupOpen();
          
         }
    });
  
    // ------------- Popup Close -------------
    document.addEventListener('click',(event)=>{
        if ( (!event.target.closest('.PopupInner') && !event.target.closest('.wishList')  && !event.target.closest('.header_whishlist_icon') && !event.target.closest('.DeleteFromList')) ||  event.target.closest('#ClosePopup') ) {
            PopupClose();
        }
    });
  
    // ------------- Header wishlist icon -------------
    document.querySelector('.header__icons .header__icon.header_whishlist_icon').addEventListener('click',function(){
        PopupOpen();
    })
  
// --------- DOMContentloaded End--------  
});



  